import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { OAuthHttpClient } from '../../services/o-auth-http-client';
import { OAuthClientAuthActions } from './o-auth-client-auth.store';

@Injectable({ providedIn: 'root' })
export class OAuthClientAuthEffects {
  public effect = createEffectFactory(OAuthClientAuthActions, this.actions$);

  public fetch$ = this.effect(OAuthClientAuthActions.fetch, () =>
    this.oAuthHttpClient.loadClientAuths(),
  );

  constructor(
    private actions$: Actions,
    private oAuthHttpClient: OAuthHttpClient,
  ) {}
}
